export const INVOICE_STATUS = {
  Invoice_Pending: 0,
  Invoice_Due: 1,
  Invoice_Paid: 2,
  Invoice_Overdue: 3,
  Invoice_Reversal: 4
}

export const InvoiceStatusString = {
  [INVOICE_STATUS.Invoice_Pending]: "Pending",
  [INVOICE_STATUS.Invoice_Due]: "Due",
  [INVOICE_STATUS.Invoice_Paid]: "Paid",
  [INVOICE_STATUS.Invoice_Overdue]: "Overdue",
  [INVOICE_STATUS.Invoice_Reversal]: "Reversal",
};
